/**
* Проверка на различие значений для чисел.
* Различно:
*  * если начальное значение пустое, а значение - нет
*  * если значение пустое, а начальное - нет
*  * если числовые значения равны
* @param {string|number|undefined} initialValue начальное значение
* @param {string|number|undefined} value значение
* @returns {boolean}
*/
const isDifferenceNumbers = (initialValue, value) => (
  (initialValue !== '' && value === '')
  || (initialValue === '' && value !== '')
  || +initialValue !== +value
);

/**
 * Проверка на различие значений
 * @param {string|number|undefined} initialValue начальное значение
 * @param {string|number|undefined} value значение
 * @returns {boolean}
 */
export function isDifference(initialValue, value) {
  if (typeof initialValue === 'number' || typeof value === 'number') return isDifferenceNumbers(initialValue, value);
  return initialValue !== value;
}
